export default {"src":"/_next/static/media/vector-line.4627db06.svg","height":69,"width":2,"blurWidth":0,"blurHeight":0};